import { actionTypes } from '../actions';

const dailyVideo = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_DAILY_VIDEO:
      return action.video;

    default:
      return state;
  }
};

export default dailyVideo;



// WEBPACK FOOTER //
// ./src/reducers/dailyVideo.js